import { base_url } from "services/routeScopeUtils"

const baseUrl = base_url()

export const EXAM_LIST_ECG = `${baseUrl}/v1/ecg/exams-list`

export const EXAM_LIST_CXRAY = `${baseUrl}/v1/cxray/exams-list`

export const EXAM_DETAIL = (examId: string) => `${baseUrl}/v1/exam/${examId}`

export const EXAM_PATCH = (examId: string) => `${baseUrl}/v1/exam/${examId}`

export const CXRAY_EXAM_UPLOAD = `${baseUrl}/v1/cxray_exam_process`

export const ECG_EXAM_UPLOAD = `${baseUrl}/v1/ecg_exam_process`

export const EXAM_UPDATE_DIAGNOSIS_STATUS = (examDiagnosesId: string) =>
  `${baseUrl}/v1/exam-diagnoses/${examDiagnosesId}/status`

export const EXAM_FEEDBACK = `${baseUrl}/v1/feedback`

export const MEDICAL_REVIEWS_LOG = `${baseUrl}/v1/medical-reviews-log`

export const EXAM_REPORT = `${baseUrl}/v1/report`

export const EXAM_REPORT_LIST = (examDiagnosesId: string) =>
  `${baseUrl}/v1/report/${examDiagnosesId}`
